import { __awaiter } from 'tslib';

const ENDPOINT = 'anghami/queue-video-encoding';
function queueVideoEncoding(gateway, params, customURL = null, customHeaders = null, isKoussa = false) {
    return __awaiter(this, void 0, void 0, function* () {
        return gateway.post(queueVideoEncoding.endpoint, params, params, customURL, customHeaders, 'json', isKoussa);
    });
}
queueVideoEncoding.endpoint = ENDPOINT;

export { queueVideoEncoding as default };
//# sourceMappingURL=queueVideoEncoding.js.map
